import React, { Component } from 'react'

import { v4 as uuidv4 } from 'uuid'

import * as echarts from 'echarts'

/**
 * Examples: https://echarts.apache.org/examples/en/index.html
 * API docs: https://echarts.apache.org/en/api.html#echarts
*/
class EChart extends Component {
  constructor (props) {
    super(props)
    this.uuid = uuidv4()
    this.chart = undefined
  }

  componentDidMount () {
    this.chart = echarts.init(document.getElementById(this.uuid), null, {
      width: this.props.width,
      height: this.props.height
    })
  }

  render () {
    if (this.chart) {
      this.chart.setOption(this.props.options)
    }

    return (
      <div id={this.uuid} />
    )
  }
}

EChart.defaultProps = {
  width: 1200,
  height: 400
}

export default EChart



// WEBPACK FOOTER //
// ./src/app/shared/components/EChart/index.js